import {fetchAuthSession} from '@aws-amplify/core';
import {useEffect, useState} from 'react';

export const useIsLoggedIn = (): {isLoggedIn: boolean; isLoading: boolean} => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Added state to track loading status

  useEffect(() => {
    fetchAuthSession()
      .then(e => {
        if (e.tokens) {
          console.log('Logged in!');
          setIsLoggedIn(true);
          setIsLoading(false);
          return;
        }

        console.log('No tokens found. Not logged in!');
        setIsLoggedIn(false);
        setIsLoading(false);
      })
      .catch(e => {
        console.error(e);
        setIsLoggedIn(false);
        setIsLoading(false);
      });
  }, []);

  return {isLoggedIn, isLoading};
};
